var text_field_default = {
  "root": "cZXe8",
  "text": "D4aQq",
  "input": "w3XGC",
  "small": "j-Ma5",
  "medium": "EtYnh",
  "large": "JTZiL",
  "webview": "DgcbP",
  "endAdornment": "t8uC0",
  "shown": "EHRjZ",
  "value": "-z8sw",
  "spinner": "t7Lhj",
  "spin": "ScqOA"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
